"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopPageSubscriptionsApp = ShopPageSubscriptionsApp;
const react_1 = __importStar(require("react"));
const shop_page_subscriptions_display_1 = require("../container/shop-page-subscriptions-display");
require("../../shared/utils/i18Next");
const window_1 = require("../../shared/contexts/window");
const page_1 = require("../../shared/contexts/page");
const site_1 = require("../../shared/contexts/site");
const client_1 = require("react-dom/client");
const dom_container_util_1 = require("../../shared/utils/dom-container-util");
const provider_1 = require("../provider");
function ShopPageSubscriptionsApp({ dataString, orderContext, subscriptionContext, hasSubscription }) {
    const model = JSON.parse(dataString);
    const modelsubscriptionContext = JSON.parse(subscriptionContext);
    const isSubscribed = hasSubscription === 'true';
    console.log(isSubscribed);
    return react_1.default.createElement(window_1.WindowProvider, null,
        react_1.default.createElement(page_1.PageProvider, null,
            react_1.default.createElement(site_1.SiteProvider, null,
                react_1.default.createElement(provider_1.ShopPageSubscriptionsDisplayProvider, { orderContext: orderContext, subscriptionContext: modelsubscriptionContext, hasSubscription: isSubscribed },
                    react_1.default.createElement(shop_page_subscriptions_display_1.ShopPageSubscriptionsDisplay, { dataModel: model })))));
}
const domSubscriptionsHomePageContainerId = '#subscriptionsInHomePage';
const domContainer = document.querySelector(domSubscriptionsHomePageContainerId);
if (domContainer) {
    const root = (0, client_1.createRoot)(domContainer);
    let model = (0, dom_container_util_1.getAndStripAttribute)("data-modelData", domContainer);
    const orderContext = (0, dom_container_util_1.getAndStripAttribute)(("data-orderContext"), domContainer);
    const subscriptionContext = (0, dom_container_util_1.getAndStripAttribute)(("data-subscriptionContext"), domContainer);
    const hasSubscription = (0, dom_container_util_1.getAndStripAttribute)(("data-hasSubscription"), domContainer);
    root.render(react_1.default.createElement(react_1.Suspense, { fallback: "loading" },
        react_1.default.createElement(ShopPageSubscriptionsApp, { dataString: model, orderContext: orderContext, subscriptionContext: subscriptionContext, hasSubscription: hasSubscription })));
}
